import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { RestApiModel } from '../../../shared/model/rest-api.model';
import { AssetUpsertArrayModel } from '../model/assets/bulk-add-asset-array.model';

/**
 * @name BulkAddAssetsService
 */
@Injectable()
export class BulkAddAssetsService {
  private endpointUpsert = RestApiModel.STARGATE_API_URL + '/assetUpsert';

  // Resolve HTTP using the constructor
  constructor(private http: HttpClient) {}

  /**
   * Post BulkAssetUpsert
   * @param {AssetUpsertModel} AssetUpsertModel
   * @returns {Observable<any>}
   */
  assetUpsert(upsertArrayModel: AssetUpsertArrayModel): Observable<any> {
    return this.http.post(this.endpointUpsert, upsertArrayModel) as Observable<
      any
    >;
  }
}
